import React, { ComponentPropsWithoutRef, memo } from 'react'

interface RadioBottomProps extends ComponentPropsWithoutRef<'input'> {
  label?: string
} 

const RadioBottom = ({label, ...props}: RadioBottomProps) => {
  return(
    <label className="formElements__radio_itemWrapper">
    <input
      type="radio"
      className="formElements__radio_defaultRadio"
      {...props}
    />
    <div className="formElements__radio_customRadio" />
    {label ? <div className="formElements__radio_label">{label}</div> : null}
  </label>
  )
}

export default memo(RadioBottom)